import { useMemo } from 'react'
import { ISetting, ISettings } from '../../model/ISettings'
import { settingsApi } from '../services/settings'

export default function useSettingsList() {
  const { data: settingMap, isSuccess } = settingsApi.useGetSettingsQuery({})

  const settingsList: Record<string, ISetting> = useMemo(
    () =>
      !settingMap
        ? {}
        : (Object.values(settingMap)
            .flatMap((settings) => settings)
            .reduce((acc, setting) => ({ ...acc, [setting.name]: setting }), {}) as Record<
            string,
            ISetting
          >),
    [isSuccess],
  )

  return {
    settingsList,
  }
}
